import React from 'react';
import { motion } from 'framer-motion';
import { FaBuilding, FaUsers, FaChild, FaBriefcase, FaGraduationCap, FaLeaf, FaMapMarkerAlt } from 'react-icons/fa';
import { translations } from '../i18n';
function About({ language }) {
  const t = translations[language];

  const censusData = [
    { label: 'एकूण लोकसंख्या', total: '१०८०', male: '५४३', female: '५३७', icon: <FaUsers /> },
    { label: 'बालके (०-६ वर्षे)', total: '२२७', male: '११८', female: '१०९', icon: <FaChild /> },
    { label: 'साक्षरता', total: '४४८', male: '२८२', female: '१६६', icon: <FaGraduationCap /> },
    { label: 'अनुसूचित जाती', total: '५७', male: '३०', female: '२७', icon: <FaUsers /> },
    { label: 'अनुसूचित जमाती', total: '१०१८', male: '५१०', female: '५०८', icon: <FaLeaf /> },
    { label: 'कार्यरत लोकसंख्या', total: '५८६', male: '३०८', female: '२७८', icon: <FaBriefcase /> },
  ];

  const schools = [
    { name: 'जि.प. शाळा, नाशेरा', udise: '******02401', category: 'प्राथमिक व उच्च प्राथमिक', management: 'स्थानिक स्वराज्य संस्था' },
    { name: 'जि.प. शाळा, थावळवाडा', udise: '******02402', category: 'प्राथमिक', management: 'स्थानिक स्वराज्य संस्था' },
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section
        className="hero"
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">{t.aboutVillage}</h1>
          <p className="page-hero-sub">नाशेरा गावाची माहिती, इतिहास व जनगणना</p>
        </div>
      </motion.section>

      {/* History Section */}
      <section className="about-section">
        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="sub-heading" style={{ fontSize: '1.8rem', marginBottom: '1.2rem' }}>नाशेरा गावाचा इतिहास</h2>
            <p style={{ color: '#555', lineHeight: 1.9, fontSize: '1.05rem', marginBottom: '1.2rem' }}>
              नाशेरा हे महाराष्ट्रातील पालघर जिल्ह्यातील मोखाडा तालुक्यातील एक ऐतिहासिक गाव आहे.
              या गावाची पिन कोड ४०१६०४ आहे. गाव त्याच्या समृद्ध आदिवासी संस्कृती आणि परंपरेसाठी ओळखले जाते.
            </p>
            <p style={{ color: '#555', lineHeight: 1.9, fontSize: '1.05rem', marginBottom: '1.5rem' }}>
              २०११ च्या जनगणनेनुसार, गावाची एकूण लोकसंख्या १०८० आहे. गावात शेती हा मुख्य व्यवसाय
              आहे आणि बहुतेक लोक शेतीवर अवलंबून आहेत. गावात प्राथमिक शाळा आणि इतर मूलभूत सुविधा उपलब्ध आहेत.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#138808', fontWeight: '600', fontSize: '1rem' }}>
              <FaMapMarkerAlt />
              <span>तालुका: मोखाडा | जिल्हा: पालघर | पिन: ४०१६०४</span>
            </div>
          </motion.div>

          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 60, scale: 0.95 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            whileHover={{ scale: 1.02 }}
            style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 15px 45px rgba(0,0,0,0.2)' }}
          >
            <img
              src="/img/5.jpeg"
              alt="नाशेरा गाव"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.6s ease' }}
              onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800'; }}
            />
          </motion.div>
        </div>
      </section>

      {/* Census Data */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">जनगणना माहिती (२०११)</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
            {censusData.map((row, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                style={{
                  background: 'white',
                  padding: '1.3rem 1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{ width: '52px', height: '52px', background: 'rgba(19,136,8,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', color: '#138808', flexShrink: 0 }}>
                  {row.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <h4 style={{ color: '#2c3e50', fontSize: '1rem', fontWeight: '700', marginBottom: '8px' }}>{row.label}</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', textAlign: 'center' }}>
                    <div style={{ background: 'rgba(19,136,8,0.08)', padding: '6px', borderRadius: '6px' }}>
                      <div style={{ fontWeight: '800', color: '#138808', fontSize: '1.1rem' }}>{row.total}</div>
                      <div style={{ fontSize: '0.75rem', color: '#666' }}>एकूण</div>
                    </div>
                    <div style={{ background: 'rgba(52,152,219,0.1)', padding: '6px', borderRadius: '6px' }}>
                      <div style={{ fontWeight: '800', color: '#3498db', fontSize: '1.1rem' }}>{row.male}</div>
                      <div style={{ fontSize: '0.75rem', color: '#666' }}>पुरुष</div>
                    </div>
                    <div style={{ background: 'rgba(233,30,99,0.08)', padding: '6px', borderRadius: '6px' }}>
                      <div style={{ fontWeight: '800', color: '#e91e63', fontSize: '1.1rem' }}>{row.female}</div>
                      <div style={{ fontSize: '0.75rem', color: '#666' }}>महिला</div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Schools */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">नाशेरा मधील शाळा</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
            {schools.map((school, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{ width: '52px', height: '52px', background: 'rgba(19,136,8,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', color: '#138808', flexShrink: 0 }}>
                  <FaBuilding />
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', marginBottom: '6px' }}>{school.name}</h4>
                  <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '3px' }}><strong style={{ color: '#138808' }}>UDISE:</strong> {school.udise}</p>
                  <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '3px' }}><strong style={{ color: '#138808' }}>प्रकार:</strong> {school.category}</p>
                  <p style={{ color: '#666', fontSize: '0.9rem' }}><strong style={{ color: '#138808' }}>व्यवस्थापन:</strong> {school.management}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
